export default __webpack_public_path__ + "static/BasisGrotesque-Medium-13792212539b03c12907641eddc186a4.woff";